export default __webpack_public_path__ + "static/media/ERRATA 10.05.2022.cd91b4c0.pdf";